import { render, staticRenderFns } from "./ForDumpList.vue?vue&type=template&id=0dcc35fc&scoped=true"
import script from "./ForDumpList.vue?vue&type=script&lang=js"
export * from "./ForDumpList.vue?vue&type=script&lang=js"
import style0 from "./ForDumpList.vue?vue&type=style&index=0&id=0dcc35fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcc35fc",
  null
  
)

export default component.exports